import { FETCH_MARKETING_CAMPAIGNS, CREATE_MARKETING_CAMPAIGNS, UPDATE_MARKETING_CAMPAIGNS, DELETE_MARKETING_CAMPAIGN } from '../types';
import api from '../api';

export const fetchMarketingCampaigns = (chainId, branchId, ids = [], onSuccess) => {
    return {
        type: FETCH_MARKETING_CAMPAIGNS,
        payload: branchId 
            ? api.restaurant.get(branchId).marketingCampaigns.getAll(ids)
            : api.chains.get(chainId).marketingCampaigns.getAll(ids),
        meta: { onSuccess }
    };
};

export const saveMarketingCampaign = (chainId, marketingCampaign, branchId, onSuccess) => {
    if (marketingCampaign.id) {
        return {
            type: UPDATE_MARKETING_CAMPAIGNS,
            payload: branchId
                ? api.restaurant.get(branchId).marketingCampaigns.update(marketingCampaign)
                : api.chains.get(chainId).marketingCampaigns.update(marketingCampaign),
            meta: { campaignId: marketingCampaign.id, toastSuccess: true, onSuccess }
        };
    } else {
        return {
            type: CREATE_MARKETING_CAMPAIGNS,
            payload: branchId
                ? api.restaurant.get(branchId).marketingCampaigns.create(marketingCampaign)
                : api.chains.get(chainId).marketingCampaigns.create(marketingCampaign),
            meta: { toastSuccess: true, onSuccess }
        };
    }
};

export const deleteMarketingCampaign = (chainId, branchId, campaign, onSuccess) => {
    return {
        type: DELETE_MARKETING_CAMPAIGN,
        payload: branchId
            ? api.restaurant.get(branchId).marketingCampaigns.delete(campaign.id)
            : api.chains.get(chainId).marketingCampaigns.delete(campaign.id),
        meta: { onSuccess, toastSuccess: true }
    };
};